  <p-select #historySelect [options]="definitionHistory()"
            optionLabel="commitMessage"
            (onShow)="openList()"
            [filter]="true"
            [showClear]="true"
            placeholder="History"
            class="w-full md:w-56"
            scrollHeight="400px"
            (onFilter)="onSearchInputChange($event.filter)"
            (onChange)="select($event.value)"
            class="w-100"
            >
    <ng-template #selectedItem let-entry >
      <span class="entry-commit-message one-line">{{ entry.commitMessage }}</span>
    </ng-template>
    <ng-template #item let-entry>
      <li
        class="item w-100"
        (click)="select(entry)"
      >
        <div class="entry-header">
          <span class="timestamp">{{ toDate(entry) | date: 'medium' }}</span>
          <span class="workflow-definition-type">{{ entry.workflowDefinitionType }}</span>
        </div>
          <span class="entry-commit-message">{{ entry.commitMessage }}</span>
      </li>
    </ng-template>
    <ng-template #footer >
      @if ( !lastPageLoaded() ){
        <div class="load-all-container">
          <a (click)="loadNextPage()" class="load-all-link">
            {{'workflow.load-more' | translate}}
          </a>
        </div>
      }
    </ng-template>
  </p-select>
